import i18n from '../../../../config/i18';

export function getPartnerLanguage(pathname = window.location.pathname): 'en' | 'ru' {
    return pathname.startsWith('/en/') ? 'en' : 'ru';
}

export function partnerPath(path: string): string {
    if (getPartnerLanguage() === 'en' && path.startsWith('/partners')) {
        return `/en${path}`;
    }

    return path;
}

export function translatePartnerText(text: string, values?: Record<string, string | number>): string {
    const key = text.replace(/\s+/g, ' ').trim();

    if (!key) {
        return text;
    }

    const leadingSpace = text.match(/^\s*/)?.[0] ?? '';
    const trailingSpace = text.match(/\s*$/)?.[0] ?? '';
    const translated = i18n.t(key, {
        ns: 'partners',
        lng: getPartnerLanguage(),
        keySeparator: false,
        nsSeparator: false,
        defaultValue: key,
        ...values,
    });

    return `${leadingSpace}${translated}${trailingSpace}`;
}
